export default
{
    title: null,
    legend: {
        layout: 'horizontal', align:'center', verticalAlign: 'bottom',
    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'spline',
        zoomType: false,
        animation: false,
        height: '350px',
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
        },

        gridLineWidth: 1,
        gridLineColor: 'rgba(200,200,200,0.3)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',
        tickInterval: 24 * 60 * 60 * 1000,
        minorGridLineColor: 'rgba(8,8,8,0.3)',
        labels: {
            rotation: 45,
            y:20
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
    },
    yAxis: [{
        title: false,
        opposite: true,
        plotLines: [{
            color: '#000000',
            width: 2,
            value: 0
        }],
        minorTickInterval: 10,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.1)',
        gridLineColor: 'rgba(200,200,200,0.2)',
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickInterval: 10,
        tickColor: '#000',
        plotBands:[{color: '#F8CCCC', from:-200, to:0  }]
    }],
    plotOptions: {
        spline: {
            animation: false,
            marker: {
                enabled: true,
                symbol: 'circle',
                radius: 1,
                states: {
                    hover: {
                        enabled: false,
                        lineWidthPlus: 0
                    }
                }
            },
            states: {
                hover: {
                    enabled: false,
                    lineWidthPlus: 0
                }
            }
        },
        areaspline: {
            animation: false,
            fillcolor: '#DC1616',
            fillOpacity: 0.5,

            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 1,
                states: {
                    hover: {
                        enabled: false,
                        lineWidthPlus: 0
                    }
                }
            },
            states: {
                hover: {
                    enabled: false,
                    lineWidthPlus: 0
                }
            }
        }
    },
    tooltip: {
        shared: true
    },

    series: [{id:'m1', name:'Denná hodnota [D.U.]', color:'#0015FF', lineWidth:1, data:[]},
        {id:'m3', name:'Dlhodobý priemer [D.U.]', color:'#D96202', lineWidth:1, data:[]},
        {id:'m2', type:'areaspline', name:'Odchýlka od dlhodobého priemeru [%]', color:'#DC1616', lineWidth:1, data:[]}
    ]

}